/* @flow */

/* eslint-disable react/prefer-stateless-function */

import React from 'react';
// $FlowIgnore
import format from 'date-fns/format';

import FaEdit from 'react-icons/lib/fa/edit';
import FaCopy from 'react-icons/lib/fa/copy';
import FaTrash from 'react-icons/lib/fa/trash';

import { Table, Button, ButtonGroup } from 'reactstrap';

// import debug from '~/utils/macros/debug.macro';
// import classes from './FileManagement.scss';

type Record = any;

// import type { Record } from '~/modules/design/types';

type PropsType = {
  data: Map<number, Record>,
  onHandleClick(id: number): void,
  onHandleCopy(id: number): void,
  onHandleDelete(id: number): void,
  onHandleRename(id: number): void,
};

export class FileManagement extends React.PureComponent<PropsType> {
  props: PropsType; // eslint-disable-line react/sort-comp

  render() {
    const listGroups = Array.from(this.props.data).map(([id, record], i) => (
      <tr key={id}>
        <td>
          <a
            role="link"
            style={{ cursor: 'pointer' }}
            tabIndex={i}
            onClick={() => this.props.onHandleClick(id)}
          >
            {record.name}
          </a>
        </td>
        {/* <td className="small text-center">{record.rev}</td> */}
        <td className="small" style={{ verticalAlign: 'middle' }}>
          {format(record.timestamp, 'MMM DD, YYYY')}
        </td>
        <td className="text-center">
          <ButtonGroup>
            <Button
              size="sm"
              title="Rename design"
              color="warning"
              onClick={() => this.props.onHandleRename(id)}
            >
              <FaEdit />
            </Button>
            <Button
              size="sm"
              title="Copy design"
              color="info"
              onClick={() => this.props.onHandleCopy(id)}
            >
              <FaCopy />
            </Button>
            <Button
              size="sm"
              title="Delete design"
              color="danger"
              onClick={() => this.props.onHandleDelete(id)}
            >
              <FaTrash />
            </Button>
          </ButtonGroup>
        </td>
      </tr>
    ));

    return (
      <Table className="small" striped responsive hover size="sm">
        <thead>
          <tr>
            <th>Name</th>
            {/* <th>Rev</th> */}
            <th>Created</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>{listGroups}</tbody>
      </Table>
    );
  }
}

// function mapStateToProps(state) {
//   const error = state.global.records.error || '';

//   const { loading, current, data } = state.global.records;

//   return {
//     loading,
//     error,
//     currentId: current,
//     data,
//   };
// }

export default FileManagement;



// WEBPACK FOOTER //
// ./src/components/FileManagement/FileManagement.js